module.exports = __webpack_public_path__ + "img/no-data.99706d3d.png";